<template>
  <drag-modal :visible="$store.state.dislog.Twelve" @cancel="reset" :title='"添加进度-" + litetit'
    :class='{ "editbox": Edit }' :width='Edit ? "840px" : "564px"'>
    <div class="navbox" v-if='Edit'>
      <Nscroll @getIndex='see' @delCopy='copydel' :openEdit='openEdit'></Nscroll>
      <div class="intopbtn" v-if='!isAllDis'>
        <!-- <a-popconfirm title="确认新增此进度吗?" ok-text="确定" cancel-text="取消" @confirm="copyNew">
          <a-button icon="plus" v-if='!openEdit'>新增本进度</a-button>
        </a-popconfirm> -->
        <a-button icon="edit"
          v-if='$common.AccAUTH($store.state.cause.accuser.id, $store.getters.stepPower.edit) && $store.getters.publicPower'
          style="margin-left:10px;" @click='openEdit = !openEdit'>{{ openEdit ? "修改" : "取消修改" }}</a-button>
      </div>
    </div>
    <a-spin :spinning="loading">
      <div class="twobox">
        <a-form-model ref="forms" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 14 }">
          <a-form-model-item label="再审时间" prop="time"
            :rules="{ required: true, message: '请选择再审时间', trigger: 'change' }">
            <a-date-picker v-model="form.time" placeholder="请选择再审时间" format='YYYY-MM-DD' type="date"
              valueFormat="YYYY-MM-DD HH:mm:ss" :disabled='openEdit' />
          </a-form-model-item>
          <a-form-model-item label="再审管辖法院" prop="court"
            :rules="{ required: true, message: '请输入再审管辖法院', trigger: 'blur' }">
            <a-input v-model="form.court" placeholder="请输入再审管辖法院" :disabled='openEdit' />
          </a-form-model-item>
          <a-form-model-item label="备注" prop="content" :rules="{ required: true, message: '请输入备注', trigger: 'change' }"
            v-if='!loading'>
            <Textarea :content='form.content' @contentVal='(element) => { form.content = element }'
              :edit='openEdit'> </Textarea>
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 24 }" style="margin-top:20px;">
            <Upload :fList='form.files' @upFileAfter='(element) => { form.files = element }' :edit='openEdit'
              v-if='!loading' :Wid='Edit ? "164px" : "110px"' />
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 24 }" v-if='!openEdit' style="text-align:center;">
            <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
              <a-button type="primary" style="width:148px;">
                提交
              </a-button>
            </a-popconfirm>
            <a-button style=" margin-left: 20px;width:148px;background:#B2C9E1;color:#fff;" @click='reset'>取消</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-spin>
  </drag-modal>

</template>
<script>
const formItem = {
  "time": null,
  "court": null,
  "content": [{ content: '' }],
  "files": []
}
import Nscroll from "@/components/nscroll"
import Upload from "@/components/uploads"
import { mapGetters, mapActions } from 'vuex'
import { zsAdd, zsEdit, zsLists } from "@/server/speed"
import Textarea from "@/components/textarea"
export default {
  name: 'Twelve',
  computed: {
    ...mapGetters([
      'litetit',
      'Edit'
    ]),
  },
  components: {
    Textarea, Upload, Nscroll
  },
  data() {
    return {
      isAllDis: this.$route.query.t,
      form: JSON.parse(JSON.stringify(formItem)),
      step: this.$store.state.StepLite,
      rules: {},
      loading: true,
      openEdit: false,
    }
  },
  created() {
    if (this.Edit) {
      this.$nextTick(() => {
        zsLists({ cause_id: this.$store.state.cause.id, step: this.step }).then(e => {
          e.list.map(ele => {
            ele.zs.content = !ele.zs.content || (ele.zs.content && ele.zs.content.length == 0) ? [{}] : ele.zs.content
            // ele.zs.content = JSON.stringify(ele.zs.content) == "{}" ? [{ content: '' }] : Object.keys(ele.zs.content).map(key => ele.zs.content[key]);
          })
          // console.log(e.list)
          this.Infokey({ key: 'infoList', value: e.list })
          this.see(0)
        })
        this.openEdit = true;
      })
    } else {
      this.loading = false;
    }
  },
  methods: {
    ...mapActions({
      Newdel: 'DisForm/copydel',
      seeInfo: 'DisForm/see',
      addNew: 'DisForm/addNew',
      Infokey: 'DisForm/setInfokey',
      reMove: 'DisForm/reMove'
    }),
    async copydel(index) {        //删除进度
      await this.Newdel({ index: index, formKey: ["time", "court", "content"], valkey: "zs" }).then(e => {
        this.form = JSON.parse(JSON.stringify(e));
        this.loading = false;
      })
    },
    confirm() {
      this.$refs.forms.validate(valid => {
        if (valid) {
          let form = JSON.parse(JSON.stringify(this.form));
          let curIndex = this.$store.state.DisForm.curIndex
          let isEditCopyAdd = this.$store.state.DisForm.copyIndex.indexOf(curIndex) >= 0 ? true : false   //当前是否是在修改下的新增
          if (form.files && form.files.length > 0) {
            form.files = form.files.map(ele => {
              return ele.upload_id || ele
            })
          }
          if (this.Edit && !isEditCopyAdd) {      //修改
            let step_id = this.$store.state.DisForm.infoList[curIndex].zs.id
            form.id = step_id;
            zsEdit(form).then(e => {
              this.$message.success({ content: '修改成功', key: 'updatable' });
              this.$parent.$parent.init(this.$store.state.cause.id)
              //   this.$store.dispatch("Case/getlist", { debtor_id: this.$route.params.id })
              this.reset()
            })
          } else {
            form.cause_id = this.$store.state.cause.id
            zsAdd(form).then(e => {
              this.$message.success({ content: '新增成功', key: 'updatable' });
              this.$parent.$parent.init(this.$store.state.cause.id)
              //   this.$store.dispatch("Case/getlist", { debtor_id: this.$route.params.id })
              this.reset()
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    copyNew() {        //新增复制进度
      this.loading = true;
      let copyItem = {
        cause_id: null,
        id: null,
        zs: formItem,
        title: this.litetit
      }
      this.addNew(copyItem).then(index => {
        this.form = JSON.parse(JSON.stringify(formItem))
        this.loading = false;
      })
    },
    async see(index) {        //查看切换 审批
      this.loading = true;
      this.seeInfo({ index: index, formKey: ["time", "court", "content"], valkey: "zs" }).then(e => {
        // console.log(e)
        this.form = JSON.parse(JSON.stringify(e));
        this.loading = false;
      })
    },
    reset() {
      this.reMove().then(e => {
        this.$refs.forms.resetFields();
        this.$store.dispatch('openkey', { key: 'Twelve', by: false })
      })
    },
    lisUpload(fileList) {
      this.form.files = fileList
    },
  }
}
</script>